import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Navbar from "../../Navbarcamera/Navbar";
import Carosello from "../caroselloap/Caroselloap";
import "./Homeap.css";
import Footer from "../../footer/Footer";
import { motion } from "framer-motion";

import { useInView } from "react-intersection-observer";
import { useTranslation } from "react-i18next";
const FadeInSection = ({ children, delay = 0 }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 50 }}
      transition={{ duration: 3, delay }} // Transition duration set to 3 seconds
    >
      {children}
    </motion.div>
  );
};

const Home = () => {
  const { t } = useTranslation();
  return (
    <>
      <Navbar />
      <Carosello></Carosello>

      <Container>
        <FadeInSection delay={0.1}>
          <h1 id="cerchi"> {t("titoloap")}</h1>
        </FadeInSection>
        <FadeInSection delay={0.2}>
          <p
            style={{ textAlign: "center", display: "flex", marginInline: "auto", marginBottom: "60px" }}
            id="bigparagrafo"
          >
            <i>"{t("pa1")}"</i>
          </p>
        </FadeInSection>
        <FadeInSection delay={0.3}></FadeInSection>
        <hr></hr>
        <FadeInSection delay={0.4}>
          <Row id="rigacentrale">
            <Col xs="12" md="12" lg="4" id="colap">
              <img src="/img/appartamenti/6.jpg" alt="" id="immagineapp"></img>
            </Col>{" "}
            <Col xs="12" md="12" lg="4" id="appartamenti">
              <h1 style={{ marginBottom: "40px", textAlign: "center" }} id="titolino">
                <i>{t("titoloap2")}</i>
              </h1>
              <p style={{ textAlign: "center" }} id="bigparagrafo">
                <i>"{t("pa2")}"</i>
              </p>
            </Col>
            <Col xs="12" md="12" lg="4" id="colap">
              <img src="/img/appartamenti/7.jpg" alt="" id="immagineapp"></img>
            </Col>
          </Row>
        </FadeInSection>
        <FadeInSection delay={0.5}>
          <Row>
            <div
              className="div"
              style={{ marginTop: "15px", width: "100%", marginBottom: "80px", background: "#e7e7e74f" }}
            >
              <h1 id="book">{t("prenota")}</h1>
            </div>
          </Row>
        </FadeInSection>
        <FadeInSection delay={0.6}>
          <Row style={{ width: "-26px" }}>
            <div className="icona">
              <a href="https://wa.me/3288351018" target="_blank">
                <img
                  src="/img/logo/whatsapp.png"
                  alt=""
                  style={{ width: "51px", marginRight: "24px" }}
                  id="logo11"
                ></img>
              </a>
              <a href="https://www.booking.com/" alt="">
                <img src="/img/logo/book.png" alt="" style={{ width: "204px" }} id="logo12"></img>
              </a>
              <a href="tel:3288351018">
                <img
                  src="/img/logo/telefono.png"
                  alt=""
                  style={{ marginLeft: "14px", width: "30px" }}
                  id="logo13"
                ></img>
              </a>
              <hr></hr>
            </div>
          </Row>
        </FadeInSection>
      </Container>

      <Footer />
    </>
  );
};

export default Home;
